import React from 'react';
import { Link } from 'react-router-dom';
import Icofont from 'react-icofont';
import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import OwlCarousel from 'react-owl-carousel3';
import VisibilitySensor from "react-visibility-sensor";

const options = {
    loop: false,
    autoplay: true,
    center: true,
    nav: false,
    items: 1,
    mouseDrag: true,
    autoplayHoverPause: true,
    responsiveClass: true,
    dots: true,
    navText: [
        "<i class='icofont-double-left'></i>",
        "<i class='icofont-double-right'></i>"
    ]
}

class HomeSlides extends React.Component {

    state = {
        isOpen: false
    };

    openModal = () => {
        this.setState({isOpen: true})
    };

    render(){
        return (
            <React.Fragment>
                <OwlCarousel 
                    className="repair-home-slides owl-carousel owl-theme"
                    {...options}
                >
                    <div className="repair-main-banner item-bg1">
                        <div className="container">
                            <div className="row justify-content-center  align-items-center">
                                <VisibilitySensor>
                                    {({ isVisible }) => (
                                        <React.Fragment>
                                            <div className="col-lg-7">
                                                <div className="col repair-banner-content">
                                                    <h2
                                                        className={
                                                            isVisible ? "animated fadeInUp" : ''
                                                        }
                                                    >
                                                        The Pitch In Club
                                                    </h2>
                                                    <div className="row justify-content-center">
                                                        <p
                                                            className={`
                                                                 ${isVisible ? "animated zoomIn" : ''} 
                                                            `}
                                                        >
                                                        <span className="home-slide-subtitle">A Simple Event Planning / Tracking Tool that helps with Organizing Events and Encourages People to Pitch In.</span>
                                                        </p>
                                                   
                                                        <Link 
                                                            to="/signup" 
                                                            className={`
                                                                btn btn-primary-orange ${isVisible ? "animated fadeInDown" : ''}
                                                            `}
                                                        >
                                                            Sign Up Free
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                          {/*                   
                                            <div className="col-lg-5">
                                                <div className="banner-video text-center">
                                                    <Link 
                                                        to="#" 
                                                        className={`
                                                            popup-youtube ${isVisible ? "animated fadeInUp" : ''}
                                                        `}
                                                        onClick={e => {e.preventDefault(); this.openModal()}}
                                                    >
                                                        <i className="icofont-ui-play"></i>
                                                    </Link>
                                                </div>
                                            </div>
                                          */ }
                                        </React.Fragment>
                                    )}
                                </VisibilitySensor>
                            </div>
                        </div>
                    </div>

                </OwlCarousel>
                
                <ModalVideo 
                    channel='youtube' 
                    isOpen={this.state.isOpen} 
                    videoId='szuchBiLrEM' 
                    onClose={() => this.setState({isOpen: false})} 
                />
            </React.Fragment>
        );
    }
}
 
export default HomeSlides;

{/*  
        THIS BLOCK OF CODE COMPRISED IMAGE 2 AND IMAGE 3 OF THE OWL CAROUSEL 
        IF ADDING BACK AT LATER TIME, DO NOT FORGET TO COMMENT OUT THE BANNER VIDEO DIV BLOCK
        SAME AS ONE CURRENTLY RENDERED

<div className="repair-main-banner item-bg2">
<div className="container">
    <div className="row justify-content-center align-items-center">
        <VisibilitySensor>
            {({ isVisible }) => (
                <React.Fragment>
                    <div className="col-lg-7">
                        <div className="col repair-banner-content">
                            <h2
                                className={
                                    isVisible ? "animated fadeInUp" : ''
                                }
                            >
                                        Computer Repairs any Brand, any Problem
                            </h2>
                            <div className="row justify-content-center">
                                <p
                                    className={
                                        isVisible ? "animated zoomIn" : ''
                                    }
                                >
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor dolore magna aliqua.
                                </p>
                                <Link 
                                    to="#" 
                                    className={`
                                        btn btn-primary-orange ${isVisible ? "animated fadeInDown" : ''}
                                    `}
                                >
                                    Sign Up Free
                                </Link>
                            </div>
                        </div>
                    </div>
                   
                    <div className="col-lg-5">
                        <div className="banner-video text-center">
                            <Link 
                                to="#" 
                                className={`
                                    popup-youtube ${isVisible ? "animated fadeInUp" : ''}
                                `}
                                onClick={e => {e.preventDefault(); this.openModal()}}
                            >
                                <i className="icofont-ui-play"></i>
                            </Link>
                        </div>
                    </div>
                   
                </React.Fragment>
            )}
        </VisibilitySensor>
    </div>
</div>
</div>

<div className="repair-main-banner item-bg3">
<div className="container">
    <div className="row justify-content-center align-items-center">
        <VisibilitySensor>
            {({ isVisible }) => (
                <React.Fragment>
                    <div className="col-lg-5">
                        <div className="col repair-banner-content">
                            <h2
                                className={
                                    isVisible ? "animated fadeInUp" : ''
                                }
                            >
                                Pitch In Club
                            </h2>
                            <div className="row justify-content-center">
                                <p
                                    className={
                                        isVisible ? "animated zoomIn" : ''
                                    }
                                >
                                    A Simple Event Planning / Tracking Tool that helps with Organizing Events and Encourages People to Pitch In.
                                </p>
                                <Link 
                                    to="#" 
                                    className={`
                                        btn btn-primary-orange ${isVisible ? "animated fadeInDown" : ''}
                                    `}
                                >
                                    Sign Up Free
                                </Link>
                            </div>
                        </div>
                    </div>
                   
                    <div className="col-lg-5">
                        <div className="banner-video text-center">
                            <Link 
                                to="#" 
                                className={`
                                    popup-youtube ${isVisible ? "animated fadeInUp" : ''}
                                `}
                                onClick={e => {e.preventDefault(); this.openModal()}}
                            >
                                <i className="icofont-ui-play"></i>
                            </Link>
                        </div>
                    </div>
                   
                </React.Fragment>
            )}
        </VisibilitySensor>
    </div>
</div>
</div>
*/}


// WEBPACK FOOTER //
// ./src/components/versionSeven/HomeSlides.js